// extracted by mini-css-extract-plugin
export var defaultWrapper = "_i9-3";
export var downloadButton = "_i9-4";
export var fileContainer = "_i9-9 _i9-7";
export var fileContainerBase = "_i9-7";
export var fileContainerFixedHeight = "_i9-8 _i9-7";
export var fileInfo = "_i9-5";
export var fileInfoWidthRestricted = "_i9-6";
export var fileType = "_i9-1";
export var fileTypeName = "_i9-2";
export var image = "_i9-0";
export var link = "_i9-b";
export var overflowEllipsis = "_i9-a";